export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Lavender-1.55fa1ef6.jpg";